// Se agrega un listener a todos los elementos con una clase
export function addEventClass (typeEvent: string, element: string, funct: any) {
  for (let i = 0; i < document.getElementsByClassName(element).length; i ++) {
    document.getElementsByClassName(element)[i].addEventListener(typeEvent, funct, false);
  }
}
